import { biLogger } from '../biLogger';
import { BiEventLogger } from '../types';

export const logHelpmateDictationButtonInteraction: BiEventLogger<{
  actionType: 'start' | 'stop';
  messageText?: string;
}> = async (state, { actionType, messageText }) => {
  await biLogger.helpmateDictationButtonInteraction(state, {
    action_type: actionType,
    ...(actionType === 'stop' && messageText !== undefined ? { message_text: messageText } : {}),
  });
};
